import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext, useCallback, useEffect } from 'react';
import classNames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import TreeNode from './treeNode';
import { getChecked, getHalfChecked, addKeys, flattenAll, delKey, getFilterData, getSpreadAttrData, getDataCheckededState, getDataCheckededStateStrictly, getAllChildKeys, getPos, getSelected, calcDropPosition } from './utils/treeUtils';
import { useChecked, useExpand, usePlantomHeightEffect, useViewportHeight, useVisibleDataMemo, useScrollToKey, useSelect } from './treeHooks';
import isBoolean from 'lodash/isBoolean';
var InternalTree = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var TreeProps = getCompProps('Tree', userDefaultProps, props); // 按钮属性需要合并一遍用户定义的默认属性

  var customPrefixcls = TreeProps.prefixCls,
      treeData = TreeProps.treeData,
      virtual = TreeProps.virtual,
      showIcon = TreeProps.showIcon,
      switcherIcon = TreeProps.switcherIcon,
      icon = TreeProps.icon,
      checkable = TreeProps.checkable,
      checkStrictly = TreeProps.checkStrictly,
      disabled = TreeProps.disabled,
      draggable = TreeProps.draggable,
      scrollToKey = TreeProps.scrollToKey,
      expandedKeysProps = TreeProps.expandedKeys,
      checkedKeysProps = TreeProps.checkedKeys,
      defaultExpandRoot = TreeProps.defaultExpandRoot,
      defaultExpandAll = TreeProps.defaultExpandAll,
      defaultExpandParent = TreeProps.defaultExpandParent,
      defaultExpandedKeys = TreeProps.defaultExpandedKeys,
      defaultCheckedKeys = TreeProps.defaultCheckedKeys,
      defaultSelectedKeys = TreeProps.defaultSelectedKeys,
      height = TreeProps.height,
      onCheck = TreeProps.onCheck,
      onExpand = TreeProps.onExpand,
      onDragStart = TreeProps.onDragStart,
      onDragOver = TreeProps.onDragOver,
      onDragLeave = TreeProps.onDragLeave,
      onDragEnter = TreeProps.onDragEnter,
      onDragEnd = TreeProps.onDragEnd,
      onDrop = TreeProps.onDrop,
      onSelect = TreeProps.onSelect,
      selectedKeysProps = TreeProps.selectedKeys,
      _TreeProps$setTreeNod = TreeProps.setTreeNodeStyle,
      setTreeNodeStyle = _TreeProps$setTreeNod === void 0 ? function () {
    return {};
  } : _TreeProps$setTreeNod,
      _TreeProps$setTreeNod2 = TreeProps.setTreeNodeClassName,
      setTreeNodeClassName = _TreeProps$setTreeNod2 === void 0 ? function () {
    return '';
  } : _TreeProps$setTreeNod2,
      innerEstimatedItemSize = TreeProps.estimatedItemSize,
      style = TreeProps.style,
      filterTreeNode = TreeProps.filterTreeNode,
      filterValue = TreeProps.filterValue,
      expandOnClickNode = TreeProps.expandOnClickNode,
      loadData = TreeProps.loadData;
  var treePrefixCls = getPrefixCls(prefixCls, 'tree', customPrefixcls); // 树样式前缀

  var treeNodePrefixCls = getPrefixCls(prefixCls, 'tree-node', customPrefixcls); // 树节点样式前缀

  var treeNodeClassName = classNames(_defineProperty({}, "".concat(treePrefixCls), true));
  var treeRootClassName = "".concat(treePrefixCls, "-root");
  var estimatedItemSize = innerEstimatedItemSize; // 节点高度

  var _React$useMemo = React.useMemo(function () {
    return flattenAll(treeData, []);
  }, [treeData]),
      flattenAllData = _React$useMemo.flattenAllData,
      maxLevel = _React$useMemo.maxLevel;

  var _useChecked = useChecked(checkStrictly, checkedKeysProps, defaultCheckedKeys, flattenAllData, maxLevel, checkable),
      _useChecked2 = _slicedToArray(_useChecked, 4),
      checkedKeys = _useChecked2[0],
      halfCheckedKeys = _useChecked2[1],
      setCheckedKeys = _useChecked2[2],
      setHalfCheckedKeys = _useChecked2[3];

  var _React$useState = React.useState(scrollToKey),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      scrollKey = _React$useState2[0],
      setScrollKey = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      start = _React$useState4[0],
      setStart = _React$useState4[1];

  var _useSelect = useSelect(selectedKeysProps, defaultSelectedKeys),
      _useSelect2 = _slicedToArray(_useSelect, 2),
      selectedKeys = _useSelect2[0],
      setSelectedKeys = _useSelect2[1];

  var listRef = React.useRef(null);
  var plantomRef = React.useRef(null);
  var rootRef = React.useRef(null);
  var scrollRef = ref || rootRef;
  var treeNodeRef = React.useRef(null);
  var dragNodeRef = React.useRef(null);
  var delayedDragEnterRef = React.useRef(null);

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isInit = _React$useState6[0],
      setIsInit = _React$useState6[1];

  var _React$useState7 = React.useState(null),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      dropPosition = _React$useState8[0],
      setDropPosition = _React$useState8[1];

  var _React$useState9 = React.useState(null),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      dragOverNodeKey = _React$useState10[0],
      setDragOverNodeKey = _React$useState10[1];

  var _React$useState11 = React.useState(new _Set()),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      loadedKeys = _React$useState12[0],
      setLoadedKeys = _React$useState12[1];

  var _React$useState13 = React.useState(new _Set()),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      loadingKeys = _React$useState14[0],
      setLoadingKeys = _React$useState14[1];

  var isSearching = React.useMemo(function () {
    return typeof filterTreeNode === 'function' && filterValue;
  }, [filterValue]);

  var _useExpand = useExpand(flattenAllData, expandedKeysProps, defaultExpandedKeys, defaultExpandAll, defaultExpandRoot, defaultExpandParent, scrollKey, isInit, filterTreeNode, isSearching),
      _useExpand2 = _slicedToArray(_useExpand, 2),
      expandedKeys = _useExpand2[0],
      setExpandedKeys = _useExpand2[1];

  var spreadAttrData = React.useMemo(function () {
    return getSpreadAttrData(flattenAllData, expandedKeys);
  }, [flattenAllData, expandedKeys]);
  var filterData = React.useMemo(function () {
    return getFilterData(spreadAttrData, filterTreeNode, isSearching);
  }, [spreadAttrData, isSearching]);

  var _useViewportHeight = useViewportHeight(height, listRef),
      _useViewportHeight2 = _slicedToArray(_useViewportHeight, 1),
      viewportHeight = _useViewportHeight2[0];

  var _useVisibleDataMemo = useVisibleDataMemo(virtual, filterData, viewportHeight, estimatedItemSize, start),
      _useVisibleDataMemo2 = _slicedToArray(_useVisibleDataMemo, 1),
      visibleData = _useVisibleDataMemo2[0];

  var index = React.useMemo(function () {
    var scrollIndex = 0;

    for (var i = 0; i < filterData.length; i++) {
      if (filterData[i].key === scrollKey) {
        scrollIndex = i;
        break;
      }
    }

    return scrollIndex;
  }, [filterData, scrollKey]);
  useScrollToKey(scrollKey, index, estimatedItemSize, scrollRef, viewportHeight, treeNodePrefixCls);
  usePlantomHeightEffect(plantomRef, filterData, estimatedItemSize);
  var handleScroll = useCallback(function () {
    if (!virtual) return;
    var scrollTop = scrollRef.current.scrollTop;
    setStart(Math.floor(scrollTop / estimatedItemSize));
    var tempStartOffset = scrollTop - scrollTop % estimatedItemSize;

    if (listRef.current && virtual) {
      listRef.current.style.transform = "translate3d(0,".concat(tempStartOffset, "px,0)");
    }
  }, [listRef, scrollRef, virtual, estimatedItemSize]);
  var handleNodeLoad = useCallback(function (loadedKeys, loadingKeys, data) {
    var key = data.key;

    if (!loadData || loadedKeys.has(key) || loadingKeys.has(key)) {
      return;
    }

    setLoadingKeys(function (prevLoadingKeys) {
      var _context;

      return new _Set(_concatInstanceProperty(_context = []).call(_context, _toConsumableArray(prevLoadingKeys), [key]));
    });
    loadData(data).then(function () {
      setLoadedKeys(function (prevState) {
        var _context2;

        return new _Set(_concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(prevState), [key]));
      });
      setLoadingKeys(function (prevState) {
        var prevLoadingKeys = cloneDeep(prevState);
        prevLoadingKeys.delete(key);
        return prevLoadingKeys;
      });
    }).catch(function (e) {
      setLoadingKeys(function (prevState) {
        var prevLoadingKeys = cloneDeep(prevState);
        prevLoadingKeys.delete(key);
        return prevLoadingKeys;
      });
      setExpandedKeys(function (preExpandedKeys) {
        return delKey(_toConsumableArray(preExpandedKeys), [key]);
      });
      throw e;
    });
  }, [loadData, setExpandedKeys]);
  var handleExpand = React.useCallback(function (key, expanded, node) {
    var newExpandedKeys = expanded ? addKeys(expandedKeys, [key]) : delKey(expandedKeys, [key]);
    onExpand && onExpand(newExpandedKeys, {
      node: node,
      expanded: expanded
    });
    setScrollKey('');
    setIsInit(false);

    if (expanded && loadData) {
      handleNodeLoad(loadedKeys, loadingKeys, node);
    }
  }, [expandedKeys, onExpand, loadData, handleNodeLoad, loadedKeys, loadingKeys]);
  var handleCheck = React.useCallback(function (key, value, node, event, pos) {
    var newCheckedKeys = value ? addKeys(checkedKeys, [key]) : delKey(checkedKeys, [key]);
    var checkState = checkStrictly ? getDataCheckededStateStrictly(newCheckedKeys) : getDataCheckededState(spreadAttrData, newCheckedKeys, halfCheckedKeys, maxLevel, false, pos, value);
    onCheck && onCheck(checkState.checkedKeys, {
      event: event,
      node: node,
      checked: value,
      halfCheckedKeys: checkState.halfCheckedKeys
    });
  }, [checkedKeys, spreadAttrData, halfCheckedKeys, maxLevel, onCheck, checkStrictly, setCheckedKeys, setHalfCheckedKeys]);
  var handleDragStart = React.useCallback(function (event, node) {
    onDragStart && onDragStart({
      event: event,
      node: node
    });
  }, [onDragStart]);
  var handleDragOver = React.useCallback(function (event, node, dropTarget) {
    var dropPos = calcDropPosition(event, dropTarget);

    if (!delayedDragEnterRef.current) {
      delayedDragEnterRef.current = {};
    }

    if (dropPos !== 0 && dropPos !== dropPosition) {
      _Object$keys(delayedDragEnterRef.current).forEach(function (key) {
        clearTimeout(delayedDragEnterRef.current[key]);
        delayedDragEnterRef.current[key] = null;
      });
    }

    setDropPosition(dropPos);
    var key = node.key,
        pos = node.pos;
    var dragNode = getDragNode();

    if (dragNode.key === node.key) {
      setDropPosition(null);
    }

    if ((dragNode === null || dragNode === void 0 ? void 0 : dragNode.key) !== key && dropPos === 0) {
      if (dragNode.key === node.key || delayedDragEnterRef.current[pos]) {
        return;
      }

      delayedDragEnterRef.current[pos] = setTimeout(function () {
        var newExpandedKeys = _toConsumableArray(expandedKeys);

        if (!node.expand) {
          newExpandedKeys = addKeys(expandedKeys, [key]);
        }

        if (!('expandedKeys' in TreeProps)) {
          setExpandedKeys(newExpandedKeys);
        }

        onExpand === null || onExpand === void 0 ? void 0 : onExpand(newExpandedKeys, {
          node: node,
          expanded: true
        });
      }, 800);
    }

    onDragOver && onDragOver({
      event: event,
      node: node
    });
  }, [TreeProps, dropPosition, expandedKeys, onDragOver, onExpand, setExpandedKeys]);
  var handleDragLeave = React.useCallback(function (event, node) {
    onDragLeave && onDragLeave({
      event: event,
      node: node
    });
  }, [onDragLeave]);
  var handleDragEnter = React.useCallback(function (event, node, _dropTarget) {
    var key = node.key;
    var dragNode = getDragNode();

    if (!dragNode) {
      return;
    }

    if ((dragNode === null || dragNode === void 0 ? void 0 : dragNode.key) !== key) {
      setDragOverNodeKey(key);
    }

    onDragEnter && onDragEnter({
      event: event,
      node: node
    });
  }, [onDragEnter]);
  var handleDragEnd = React.useCallback(function (event, node) {
    setDragOverNodeKey(null);
    onDragEnd && onDragEnd({
      event: event,
      node: node
    });
  }, [onDragEnd]);
  var handleDrop = React.useCallback(function (event, node, dragNode, dragNodesKeys) {
    var _context3;

    setDragOverNodeKey(null);
    setDropPosition(null);
    var pos = getPos(flattenAllData, dragNodesKeys);

    var keys = _concatInstanceProperty(_context3 = getAllChildKeys(flattenAllData, pos)).call(_context3, dragNodesKeys);

    onDrop && onDrop({
      event: event,
      node: node,
      dragNode: dragNode,
      dragNodesKeys: keys,
      dropPosition: dropPosition
    });
  }, [flattenAllData, onDrop, dropPosition]);
  var handleSelect = React.useCallback(function (event, node, key) {
    var checked = getChecked(checkedKeys, key);
    onSelect && onSelect([key], {
      node: node,
      event: event,
      checked: checked
    });
  }, [onSelect, setSelectedKeys, checkedKeys]);

  var getSelectable = function getSelectable(selectable) {
    if (isBoolean(selectable)) {
      return selectable;
    }

    return true;
  };

  var getCheckable = function getCheckable(checkableProps, itemCheckable) {
    return isBoolean(itemCheckable) ? itemCheckable : checkableProps;
  };

  var getDisabled = function getDisabled(disabledProps, itemDisabled) {
    return isBoolean(itemDisabled) ? itemDisabled : disabledProps;
  };

  var getDragNode = function getDragNode() {
    return dragNodeRef.current;
  };

  var setDragNode = function setDragNode(nodeData) {
    dragNodeRef.current = nodeData;
  };

  useEffect(function () {
    if (scrollToKey) {
      setSelectedKeys([scrollToKey]);
      setScrollKey(scrollToKey);
    } else {
      setSelectedKeys([]);
    }
  }, [scrollToKey]);
  useEffect(function () {
    setHalfCheckedKeys(halfCheckedKeys);
  }, [halfCheckedKeys]);
  return /*#__PURE__*/React.createElement("div", {
    className: treeNodeClassName,
    style: style,
    ref: scrollRef,
    onScroll: handleScroll
  }, /*#__PURE__*/React.createElement("div", {
    ref: plantomRef,
    className: "".concat(treePrefixCls, "-plantom")
  }), /*#__PURE__*/React.createElement("div", {
    className: treeRootClassName,
    ref: listRef
  }, visibleData && _mapInstanceProperty(visibleData).call(visibleData, function (item) {
    var checked = getChecked(checkedKeys, item.key);
    var indeterminate = getHalfChecked(halfCheckedKeys, item.key);
    item.nodeKey = item.key;
    item.onExpand = handleExpand;
    item.onCheck = handleCheck;
    item.onDragStart = handleDragStart;
    item.onDragOver = handleDragOver;
    item.onDragLeave = handleDragLeave;
    item.onDragEnter = handleDragEnter;
    item.onDragEnd = handleDragEnd;
    item.onDrop = handleDrop;
    item.onSelect = handleSelect;
    item.checked = checked;
    item.selected = getSelected(selectedKeys, item.key);
    item.indeterminate = indeterminate;
    item.disabled = getDisabled(disabled, item.disabled);
    item.showIcon = showIcon || false;
    item.checkable = getCheckable(checkable, item.checkable); // 哪个优先

    item.selectable = getSelectable(item.selectable);
    item.icon = item.icon || icon;
    item.switcherIcon = item.switcherIcon || switcherIcon;
    item.estimatedItemSize = estimatedItemSize;
    item.draggable = draggable;
    item.className = setTreeNodeClassName(_extends({}, item));
    item.style = setTreeNodeStyle(_extends({}, item));
    item.getDragNode = getDragNode;
    item.setDragNode = setDragNode;
    item.dragOver = dragOverNodeKey === item.key && dropPosition === 0;
    item.dropPosition = dropPosition;
    item.expandOnClickNode = expandOnClickNode;
    item.loading = loadingKeys.has(item.key) && !loadedKeys.has(item.key);
    item.loadData = loadData;
    return /*#__PURE__*/React.createElement(TreeNode, _extends({}, item, {
      key: item.key,
      ref: treeNodeRef
    }));
  })));
});
var Tree = InternalTree;
Tree.displayName = 'Tree';
export default Tree;